import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "row row-layout mb-4"
}
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = {
  key: 0,
  class: "col-4"
}
const _hoisted_7 = { class: "row row-title align-items-end mb-4" }
const _hoisted_8 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_9 = {
  key: 1,
  class: "col-2"
}
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row row-content mb-5" }
const _hoisted_12 = { class: "row row-image mb-5" }
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = { class: "col-8" }
const _hoisted_15 = {
  key: 0,
  class: "row"
}
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "col-4" }
const _hoisted_18 = { class: "col-4" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = {
  key: 0,
  class: "col-12"
}
const _hoisted_23 = {
  key: 2,
  class: "row row-button"
}
const _hoisted_24 = { class: "col-12 mb-3" }
const _hoisted_25 = {
  key: 0,
  class: "col-12"
}
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-8" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = { class: "col-auto" }
const _hoisted_31 = { class: "col-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_AdvancedPanelSwitcher = _resolveComponent("AdvancedPanelSwitcher")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TitleMetaInputComponent = _resolveComponent("TitleMetaInputComponent")!
  const _component_AdvancedPanel = _resolveComponent("AdvancedPanel")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_InputImage = _resolveComponent("InputImage")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_PageLinkPicker = _resolveComponent("PageLinkPicker")!
  const _component_ImageContainerDimensionsDetail = _resolveComponent("ImageContainerDimensionsDetail")!
  const _component_ImagePositioningDetail = _resolveComponent("ImagePositioningDetail")!
  const _component_ImageOverlaysDetail = _resolveComponent("ImageOverlaysDetail")!
  const _component_ExtraMetadataSection = _resolveComponent("ExtraMetadataSection")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !_ctx.isReady
    }, null, 8, ["spin"]),
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!_ctx.isArticleHeading && !_ctx.isOverview)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_InputSelect, {
                        modelValue: _ctx.contentBlock.layout_code,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contentBlock.layout_code) = $event)),
                          _ctx.onLayoutChanged
                        ],
                        label: _ctx.$t('layout'),
                        name: "layout",
                        selectText: _ctx.$t('selectText'),
                        options: _ctx.enumLayoutCode,
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "selectText", "options", "errors"])
                    ]),
                    (_ctx.showImageColWidth)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_InputSelect, {
                            modelValue: _ctx.contentBlock.image_col_width_code,
                            "onUpdate:modelValue": [
                              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentBlock.image_col_width_code) = $event)),
                              _ctx.onChange
                            ],
                            label: _ctx.$t('cms.imageColWidth'),
                            name: "image_col_width_code",
                            selectText: _ctx.$t('selectText'),
                            options: _ctx.enumColumnSizeCode,
                            "can-clear": true,
                            errors: _ctx.errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "selectText", "options", "errors"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('content')
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.isAdvancedOptionsAvailable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_AdvancedPanelSwitcher, {
                        class: "mb-3",
                        "is-advanced": _ctx.isAdvancedTitleMeta,
                        errors: _ctx.errors,
                        onToggleAdvanced: _ctx.toggleAdvancedTitleMeta
                      }, null, 8, ["is-advanced", "errors", "onToggleAdvanced"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isOverview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_InputSelect, {
                        modelValue: _ctx.contentBlock.title_size_code,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentBlock.title_size_code) = $event)),
                          _ctx.onChange
                        ],
                        label: _ctx.$t('size'),
                        name: "size",
                        selectText: _ctx.$t('selectText'),
                        options: _ctx.enumTitleSizeCode,
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "selectText", "options", "errors"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.contentBlock.title.nl,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contentBlock.title.nl) = $event)),
                      _ctx.onChange
                    ],
                    label: _ctx.$t('title'),
                    name: "title",
                    rules: "max:500",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ])
              ]),
              _createVNode(_component_AdvancedPanel, {
                "is-show-when-advanced": true,
                "is-advanced": _ctx.isAdvancedTitleMeta,
                class: "bg-light pt-3 ms-3 mb-3 p-3 pt-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TitleMetaInputComponent, {
                    modelValue: _ctx.contentBlock.title_meta,
                    errors: _ctx.errors,
                    "onUpdate:modelValue": _ctx.onTitleMetaUpdate
                  }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["is-advanced"]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_InputTextEditor, {
                  modelValue: _ctx.contentBlock.content.nl,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contentBlock.content.nl) = $event)),
                    _ctx.onChange
                  ],
                  name: "content",
                  toolbar: _ctx.contentToolbar,
                  "editor-options": _ctx.editorOptions,
                  class: "col-12",
                  errors: _ctx.errors
                }, null, 8, ["modelValue", "onUpdate:modelValue", "toolbar", "editor-options", "errors"])
              ]),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('image')
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_InputImage, {
                    "onUpdate:modelValue": _ctx.setImageKey,
                    onImageCleared: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setImageKey(null))),
                    modelValue: _ctx.existingDocumentKey,
                    typeCode: _ctx.docType,
                    module: _ctx.DpModuleEnum.CMS
                  }, null, 8, ["onUpdate:modelValue", "modelValue", "typeCode", "module"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (!_ctx.isOverview)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.contentBlock.image.title.nl,
                            "onUpdate:modelValue": [
                              _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contentBlock.image.title.nl) = $event)),
                              _ctx.onChange
                            ],
                            label: _ctx.$t('title'),
                            name: "image_title",
                            errors: _ctx.errors
                          }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_InputSelect, {
                            modelValue: _ctx.contentBlock.image.border_type_code,
                            "onUpdate:modelValue": [
                              _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contentBlock.image.border_type_code) = $event)),
                              _ctx.onChange
                            ],
                            label: _ctx.$t('cms.borderType'),
                            name: "border_type",
                            selectText: _ctx.$t('selectText'),
                            options: _ctx.enumBorderTypeCode,
                            rules: "required",
                            errors: _ctx.errors
                          }, null, 8, ["modelValue", "label", "selectText", "options", "errors", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          (_ctx.contentBlock.image.border_type_code && _ctx.contentBlock.image.border_type_code !== 'NONE')
                            ? (_openBlock(), _createBlock(_component_InputSelect, {
                                key: 0,
                                modelValue: _ctx.contentBlock.image.border_width_code,
                                "onUpdate:modelValue": [
                                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contentBlock.image.border_width_code) = $event)),
                                  _ctx.onChange
                                ],
                                label: _ctx.$t('cms.borderWidth'),
                                name: "border_width",
                                selectText: _ctx.$t('selectText'),
                                options: _ctx.enumBorderWidthCode,
                                errors: _ctx.errors
                              }, null, 8, ["modelValue", "label", "selectText", "options", "errors", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_InputSelect, {
                            modelValue: _ctx.contentBlock.image.horizontal_image_shift_code,
                            "onUpdate:modelValue": [
                              _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contentBlock.image.horizontal_image_shift_code) = $event)),
                              _ctx.onChange
                            ],
                            label: _ctx.$t('cms.horizontalShift'),
                            name: "horizontal_image_shift_code",
                            selectText: _ctx.$t('selectText'),
                            options: _ctx.enumHorizontalImageShift,
                            errors: _ctx.errors
                          }, null, 8, ["modelValue", "label", "selectText", "options", "errors", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_InputSelect, {
                            modelValue: _ctx.contentBlock.image.vertical_image_shift_code,
                            "onUpdate:modelValue": [
                              _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contentBlock.image.vertical_image_shift_code) = $event)),
                              _ctx.onChange
                            ],
                            label: _ctx.$t('cms.verticalShift'),
                            name: "vertical_image_shift_code",
                            selectText: _ctx.$t('selectText'),
                            options: _ctx.enumVerticalImageShift,
                            errors: _ctx.errors
                          }, null, 8, ["modelValue", "label", "selectText", "options", "errors", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_input_select, {
                            modelValue: _ctx.contentBlock.image.lightbox_layout_code,
                            "onUpdate:modelValue": [
                              _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contentBlock.image.lightbox_layout_code) = $event)),
                              _ctx.onChange
                            ],
                            label: _ctx.$t('cms.lightboxLayout'),
                            name: "lightbox_layout_code",
                            selectText: _ctx.$t('selectText'),
                            options: _ctx.enumLightboxLayoutCode,
                            rules: "required",
                            errors: _ctx.errors
                          }, null, 8, ["modelValue", "label", "selectText", "options", "errors", "onUpdate:modelValue"])
                        ]),
                        (!_ctx.isArticleHeading && !_ctx.isOverview)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createVNode(_component_PageLinkPicker, {
                                payload: _ctx.pageLinkImagePayload,
                                errors: _ctx.errors,
                                onChanged: _ctx.onPageLinkPickerImageChanged
                              }, null, 8, ["payload", "errors", "onChanged"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (!_ctx.isOverview)
                ? (_openBlock(), _createBlock(_component_ExtraMetadataSection, {
                    key: 1,
                    id: _ctx.metadataSectionId,
                    activeLabels: _ctx.activeMetadataLabels,
                    class: "mb-5"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_ImageContainerDimensionsDetail, {
                        key: `container_dimensions_${_ctx.metadataRevision}`,
                        modelValue: _ctx.contentBlock.image.container_dimensions,
                        "onUpdate:modelValue": [
                          _cache[12] || (_cache[12] = ($event: any) => ((_ctx.contentBlock.image.container_dimensions) = $event)),
                          _ctx.onChange
                        ],
                        name: _ctx.$t('cms.imageContainer'),
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])),
                      (_openBlock(), _createBlock(_component_ImagePositioningDetail, {
                        key: `positioning_${_ctx.metadataRevision}`,
                        modelValue: _ctx.contentBlock.image.positioning,
                        "onUpdate:modelValue": [
                          _cache[13] || (_cache[13] = ($event: any) => ((_ctx.contentBlock.image.positioning) = $event)),
                          _ctx.onChange
                        ],
                        name: _ctx.$t('cms.imagePositioning'),
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])),
                      (_openBlock(), _createBlock(_component_ImageOverlaysDetail, {
                        key: `overlays_${_ctx.metadataRevision}`,
                        modelValue: _ctx.contentBlock.image.overlays,
                        "onUpdate:modelValue": [
                          _cache[14] || (_cache[14] = ($event: any) => ((_ctx.contentBlock.image.overlays) = $event)),
                          _ctx.onChange
                        ],
                        name: _ctx.$t('cms.overlays'),
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"]))
                    ]),
                    _: 1
                  }, 8, ["id", "activeLabels"]))
                : _createCommentVNode("", true),
              (!_ctx.isArticleHeading && !_ctx.isOverview)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_InputCheckboxBoolean, {
                        modelValue: _ctx.useButton,
                        "onUpdate:modelValue": [
                          _cache[15] || (_cache[15] = ($event: any) => ((_ctx.useButton) = $event)),
                          _ctx.onChange
                        ],
                        label: _ctx.$t('useButton'),
                        name: "useButton",
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                    ]),
                    (_ctx.useButton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.contentBlock.button.button_text.nl,
                                "onUpdate:modelValue": [
                                  _cache[16] || (_cache[16] = ($event: any) => ((_ctx.contentBlock.button.button_text.nl) = $event)),
                                  _ctx.onChange
                                ],
                                label: _ctx.$t('buttonText'),
                                name: "buttonText",
                                rules: "max:100",
                                errors: _ctx.errors
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_InputSelect, {
                                modelValue: _ctx.contentBlock.button_horizontal_position_code,
                                "onUpdate:modelValue": [
                                  _cache[17] || (_cache[17] = ($event: any) => ((_ctx.contentBlock.button_horizontal_position_code) = $event)),
                                  _ctx.onChange
                                ],
                                label: _ctx.$t('cms.horizontalAlignment'),
                                name: "button_horizontal_position_code",
                                selectText: _ctx.$t('selectText'),
                                options: _ctx.enumObjectHorizontalPosition,
                                errors: _ctx.errors
                              }, null, 8, ["modelValue", "label", "selectText", "options", "errors", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_InputSelect, {
                                modelValue: _ctx.contentBlock.button.button_layout_code,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.contentBlock.button.button_layout_code) = $event)),
                                options: _ctx.enumButtonLayoutCode,
                                label: _ctx.$t('layout'),
                                name: "buttonLayout",
                                selectText: _ctx.$t('selectText'),
                                errors: _ctx.errors
                              }, null, 8, ["modelValue", "options", "label", "selectText", "errors"])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_PageLinkPicker, {
                                payload: _ctx.pageLinkButtonPayload,
                                "enable-no-link": false,
                                errors: _ctx.errors,
                                onChanged: _ctx.onPageLinkPickerButtonChanged
                              }, null, 8, ["payload", "errors", "onChanged"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}